import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import api from '../api';

export default function UsuariosInvitacionesPage() {
  const { cid } = useParams();
  const [miembros, setMiembros] = useState([]);
  const [invitaciones, setInvitaciones] = useState([]);
  const [padron, setPadron] = useState([]);
  const [email, setEmail] = useState('');
  const [unidadIds, setUnidadIds] = useState([]);
  const [enlace, setEnlace] = useState('');
  const [error, setError] = useState('');

  const load = () => {
    api.get(`/gastos-comunes/condominios/${cid}/miembros`).then((r) => setMiembros(r.data)).catch(() => {});
    api.get(`/gastos-comunes/condominios/${cid}/invitaciones`).then((r) => setInvitaciones(r.data)).catch(() => {});
    api.get(`/gastos-comunes/condominios/${cid}/padron`).then((r) => setPadron(r.data));
  };

  useEffect(() => {
    if (cid) load();
  }, [cid]);

  const toggleUnidad = (id) => {
    setUnidadIds((prev) => (prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]));
  };

  const invitar = async (e) => {
    e.preventDefault();
    setError('');
    setEnlace('');
    try {
      const { data } = await api.post(`/gastos-comunes/condominios/${cid}/invitaciones`, {
        email,
        rolGc: 'propietario',
        unidadIds
      });
      setEnlace(data.enlace);
      setEmail('');
      setUnidadIds([]);
      load();
    } catch (err) {
      setError(err.response?.data?.error || err.message);
    }
  };

  const reenviar = async (id) => {
    try {
      const { data } = await api.post(`/gastos-comunes/condominios/${cid}/invitaciones/${id}/reenviar`);
      setEnlace(data.enlace);
      load();
    } catch (err) {
      setError(err.response?.data?.error || err.message);
    }
  };

  const copy = () => {
    navigator.clipboard.writeText(enlace).catch(() => prompt('Copiar:', enlace));
  };

  return (
    <>
      <div className="page-header">
        <h2>Usuarios e invitaciones</h2>
        <p>Acceso web (login). El padrón de nombres se gestiona en Propietarios.</p>
      </div>
      {error && <div className="alert alert-error">{error}</div>}

      <div className="card">
        <h3 className="card-title">Invitar acceso portal</h3>
        <form onSubmit={invitar}>
          <div className="field">
            <label>Correo login</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
          </div>
          <div className="field">
            <label>Departamentos vinculados</label>
            <div className="checkbox-list">
              {padron.map((u) => (
                <label key={u.id}>
                  <input type="checkbox" checked={unidadIds.includes(u.id)} onChange={() => toggleUnidad(u.id)} />
                  {u.codigoDepto}
                  {u.titularNombre ? ` — ${u.titularNombre}` : ''}
                </label>
              ))}
            </div>
          </div>
          <button type="submit" className="btn" disabled={!unidadIds.length}>
            Generar enlace
          </button>
        </form>
        {enlace && (
          <>
            <div className="link-box">{enlace}</div>
            <button type="button" className="btn secondary" onClick={copy}>
              Copiar enlace
            </button>
          </>
        )}
      </div>

      <div className="card">
        <h3 className="card-title">Invitaciones pendientes</h3>
        <div className="table-wrap">
          <table className="data-table">
            <thead>
              <tr>
                <th>Email</th>
                <th>Vence</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {invitaciones.map((inv) => (
                <tr key={inv.id || inv._id}>
                  <td>{inv.email}</td>
                  <td>{inv.expiresAt ? new Date(inv.expiresAt).toLocaleDateString('es-CL') : '—'}</td>
                  <td>
                    <button type="button" className="btn secondary" onClick={() => reenviar(inv.id || inv._id)}>
                      Reenviar
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="card">
        <h3 className="card-title">Usuarios con acceso</h3>
        <div className="table-wrap">
          <table className="data-table">
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Email</th>
                <th>Rol GC</th>
              </tr>
            </thead>
            <tbody>
              {miembros.map((m) => (
                <tr key={m.id}>
                  <td>{m.user?.nombre || '—'}</td>
                  <td>{m.user?.email}</td>
                  <td>{m.rolGc}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}
